export default __webpack_public_path__ + "static/media/ic_channel_0.485f3b0e.svg";